import { CreateProcess } from "redux-process";

import serializeObject from "../../utils/SerializeObject";

export const FeedbackRequestsGet = CreateProcess({
	method: "GET",
	name: "FeedbackRequestsGet",
	type: "FEEDBACK:REQUESTS.GETBULK",

	request: (props) => {
		const queryParams = serializeObject(props.params);
		return {
			url: `/api/feedback-request/?${queryParams}`,
		};
	},

	success: (response) => {
		const { data } = response;
		const { count } = data;

		const feedbackRequests = data.feedbackRequests.map((request) => {
			request.id = request._id;
			request.requestedBy = request.requested_by;
			request.requestedTo = request.requested_to;

			return request;
		});

		return {
			count,
			feedbackRequests,
		};
	},
});

export const FeedbackRequestsDismiss = CreateProcess({
	method: "POST",
	name: "DismissFeedbackRequest",
	type: "FEEDBACK:REQUESTS.Dismiss",

	request: (props) => ({
		url: `/api/feedback-request/dismiss/${props.feedbackRequestID}/?`,
	}),

	success: (response) => response.data,
});

export const FeedbackRequestsCreate = CreateProcess({
	method: "POST",
	name: "CreateFeedbackRequest",
	type: "FEEDBACK:REQUESTS.Create",

	request: (props) => ({
		url: "/api/feedback-request/?",
		payload: props.payload,
	}),

	success: (response) => response.data,
});

export const RequestFeedbackCheck = CreateProcess({
	method: "POST",
	name: "CheckFeedbackRequest",
	type: "FEEDBACK:REQUESTS.Check",

	request: (props) => ({
		url: "/api/feedback-request/check/?",
		payload: props.payload,
	}),

	success: (response) => response.data,
});

export const FeedbackRequestsDelete = CreateProcess({
	method: "DELETE",
	name: "DeleteFeedbackRequest",
	type: "FEEDBACK:REQUESTS.Delete",

	request: (props) => ({
		url: `/api/feedback-request/delete/${props.feedbackRequestID}/?`,
	}),

	success: (response) => response.data,
});

export const FeedbackRequestsEdit = CreateProcess({
	method: "POST",
	name: "EditFeedbackRequest",
	type: "FEEDBACK:REQUESTS.EDIT",

	request: (props) => ({
		url: `/api/feedback-request/edit/${props.feedbackRequestID}/?`,
		payload: props.payload,
	}),

	success: (response) => response.data,
});
